<template>
    <div style="width: 100%; height: 100%; margin: 0; padding: 20px; overflow-y: auto; text-align: left; box-sizing: border-box;">
      <side-menu-header :role="store.state.user.role"></side-menu-header>
      <div class="content-positining-admin text input-forms-size">
          <div>
            <div class="user__headers">
              {{firstName}} {{surname}}
            </div>
              <!-- <div style="padding-top: 3%; padding-bottom: 3%;">To start using Adway please create an account</div> -->
              <div class="input-area" aria-autocomplete="off" style="margin-top: 55px;">
                <div class="admin-input-field-area">
                    <div class="admin-text-style">First Name</div>
                    <input class="input-filed" type="text" placeholder="eg. Jane" v-model="firstName">
                </div>
                <div class="admin-input-field-area">
                    <div class="admin-text-style">Last Name</div>
                    <input class="input-filed" type="text" name="" placeholder="eg. Doe" v-model="surname">
                </div>
                <div class="admin-input-field-area">
                    <div class="admin-text-style">Email</div>
                    <input class="input-filed" type="text" name="" placeholder="eg. myemail@myemail.com" v-model="email" disabled="disabled">
                </div>
                <div class="admin-input-field-area">
                    <div class="admin-text-style">Phone number</div>
                    <input class="input-filed" type="text" name="" placeholder="eg. 123-456-7890" v-model="phone" maxlength="50">
                </div>
                <div class="admin-input-field-area">
                  <div class="admin-text-style">Company name</div>
                  <input class="input-filed" type="text" name="" placeholder="eg. my company 1" v-model="companyName">
                </div>
                <div class="admin-input-field-area">
                    <div class="admin-text-style">Company website</div>
                    <input class="input-filed" type="text" name="" placeholder="eg. mycompany.com" v-model="companyWebSite">
                </div>
                <!-- <div class="admin-input-field-area">
                  <div class="admin-text-style">Password</div>
                  <input class="input-filed" type="password" name="password" placeholder="eg. password" autocomplete="auto" v-model="password">
                </div> -->
                <div class="check-boxs" style="margin-bottom: 10px;">
                    <div>
                        <input type="checkbox" name="adway-notification" id="adway-notification" v-model="notificationCB">
                        <label for="adway-notification">I want to receive Adway's campaign notifications</label>
                    </div>
                </div>
                <div style="display: inline;">
                    <button class="adway-btn-2-class" @click="submit" style="height: 60px;">
                      <clip-loader :loading="activePasswordChange || activeMakeRequest"/>
                      <div class="btn__context__reverse">
                        <img src="./../../assets/update.svg" alt="update account" style="position: absolute; margin-right: 8px; top: -6px;">
                        <span v-if="!activePasswordChange && !activeMakeRequest" class="btn__text__normal" style="margin-left: 38px;">Update Account</span>
                      </div>
                    </button>
                </div>
              </div>
          </div>
      </div>
    </div>
</template>

<script>
import SideMenuHeader from './../../components/design/SideMenuHeader.vue'
import HTTPRequest from './../../plugins/utils/HttpRequest.js'
import store from '@store/index.js'
import { mapGetters } from 'vuex'
import ClipLoader from 'vue-spinner/src/ClipLoader.vue'
import toast from '@utils/toast.js'
export default {
  name: 'SignUpAdvertiser',
  components: {
    SideMenuHeader,
    ClipLoader
  },
  data: function () {
    return {
      fullname: '',
      email: '',
      companyName: '',
      phone: '',
      companyWebSite: '',
      password: '',
      repeatPassword: '',
      firstName: '',
      surname: '',
      notificationCB: false,
      advertiser: Object,
      store: store,
      activePasswordChange: false,
      activeMakeRequest: false
    }
  },
  methods: {
    submit () {
      if (this.stateDifference()) {
        this.activeMakeRequest = true
        this.makeRequest()
      }

      if (this.password.length > 0) {
        this.activePasswordChange = true
        this.changePassword()
      }
    },
    stateDifference () {
      if (this.user.firstName !== this.firstName) {
        return true
      }
      if (this.user.surname !== this.surname) {
        return true
      }
      if (this.user.phone !== this.phone) {
        return true
      }
      if (!this.user.ADWAY_notifications && this.notificationCB) {
        return true
      }
      return false
    },
    changePassword () {
      var url = '/user/password/change'
      var body = {
        data: {
          secret: this.password
        }
      }

      this.request(url, 'POST', body).then((response) => {
        if (response.code === 0) {
          toast.successMessage('Password is reset')
          this.reLogin()
        } else {
          toast.errorMessage(response.message)
          this.activePasswordChange = false
          if (response.code === 112) {
            this.checkTokenConditions(this.changePassword)
          }
        }
      }).catch((error) => {
      })
    },
    makeRequest () {
      var body = {
        data: {
          firstname: this.firstName,
          surname: this.surname,
          phone: this.phone,
          website: this.companyWebSite,
          email: this.email,
          company: this.companyName,
          ADWAY_notifications: this.notificationCB ? 1 : 0
        }
      }
      var url = '/set/profile'
      this.request(url, 'POST', body).then(response => {
        if (response.code === 0) {
          this.activeMakeRequest = false
          toast.successMessage('Profile updated')
          this.getProfile();
        } else {
          if (response.code === 112) {
            this.checkTokenConditions(this.makeRequest)
          }
        }
      }).catch((error) => {
      })
    },
    getProfile () {
      this.request('/get/profile', 'POST', {}).then((response) => {
        if (response.code === 0) {
          store.commit('setUser', response.data[0])
        } else {
          toast.errorMessage(response.message)
          if (response.code === 112) {
            this.checkTokenConditions(this.getProfile)
          }
        }
      }).catch((error) => {
        this.activeMakeRequest = false
      })
    },
    reLogin () {
      var request = new HTTPRequest()
      var url = '/user/login'
      var body = {
        user: this.user.email,
        API_KEY: '',
        data: {
          secret: this.password,
          local_time: this.$moment(new Date()).format(),
        }
      }
      this.password = ''
      request.makeRequest('POST', url, body).then((response) => {
        if (response.code === 0) {
          var parseResponse = JSON.parse(response)
          try {
            store.commit('setToken', parseResponse.data[0])
            store.commit('setDriver', parseResponse.data[0].driver)
          } catch (error) {
            toast.errorMessage('Error in writting data, please report to our developers')
          }
          this.activePasswordChange = false
        } else {
          if (response.code === 112) {
            this.checkTokenConditions(this.reLogin)
          }
        }
      }).catch((error) => {
        this.activePasswordChange = false
      })
    },
    refreshParameters () {
      this.firstName = this.user.firstname
      this.surname = this.user.surname
      this.email = this.user.email
      this.phone = this.user.phone
      this.companyWebSite = this.user.website
      this.companyName = this.user.company
      this.password = ''
      this.notificationCB = this.user.ADWAY_notifications === null || this.user.ADWAY_notifications === '' ? false : this.user.ADWAY_notifications
    },
    checkTokenConditions (callback) {
      try{
        var expiresDate = new Date(this.token.expires)
      } catch (err) {
        this.$router.push('/login')
      }
      var now = new Date()
      if (expiresDate <= now) {
        this.store.commit('setToken', {})
        this.$router.push('/login')
      } else {
        var body = {
          code: '',
          refresh_token: this.token.refresh_token
        }
        this.request('/refresh/token', 'POST', body).then((response) => {
          if (response.code === 0 ) {
            store.commit('setToken', response.data[0])
            store.commit('setDriver', response.data[0].driver)
            callback()
          } else if (response.code === 112) {
            this.store.commit('setToken', {})
            this.$router.push('/login')
          }
        }).catch((error) => {
        })
      }
      var token = this.token
      token.redirect = false
      this.store.commit('setToken', token)
    }
  },
  created: function () {
    this.refreshParameters()
    this.getProfile()
  },
  computed: {
      ...mapGetters({
        user: 'getUser'
    })
  },
  watch: {
    user: function (value) {
      this.refreshParameters()
    }
  }
}
</script>

<style scoped>
  .admin-input-field-area {
    margin-bottom: 15px;
  }

  .adway-btn-2-class{
    width: 238px;
  }

  .admin-text-style{
    margin-bottom: 5px;
    font-size: 14px;
  }

  input {
    border: 1px solid #CCD4E0;
    border-radius: 5px;
    box-shadow: 0px 0px 6px rgba(81, 95, 152, 0.161);
    height: 35px;
    box-sizing: border-box;
  }

  button{
    cursor: pointer;
  }

  .check-boxs div{
    display: flex;
    align-items: center;
  }

  .check-boxs label{
    font-size: 14px;
  }

  #adway-notification {
    box-shadow: none;
  }

.btn__context__reverse{
  padding: 0px calc(50% - 86px) 0px calc(50% - 86px);
  position: relative;
}

  @media only screen and (max-width: 600px) {
    .admin-text-style{
      font-size: 12px;
    }

    .adway-btn-2-class{
      width: 100%;
    }

    .input-filed{
      width: 100% !important;
      padding-left: 10px !important;
    }

    .input-forms-size{
      margin-top: 30px;
      width: 100%;
    }

    input::placeholder {
      position: relative;
      left: 0;
    }

    .check-boxs label{
      font-size: 10px;
    }

    .adway-btn-2-class{
      padding: 10px;
      height: auto;
    }

    .adway-btn-2-class span{
      font-size: 12px;
    }
  }
</style>
